<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import RealEstateFinanceInstallmentBeneficiaries from './RealEstateFinanceInstallmentBeneficiaries.vue';
import RealEstateFinanceInstallmentHistory from './RealEstateFinanceInstallmentHistory.vue';
import RealEstateFinanceInstallmentPaymentStatus from './RealEstateFinanceInstallmentPaymentStatus.vue';
import RealEstateFinanceInstallmentSummary from './RealEstateFinanceInstallmentSummary.vue';
import RealEstateFinanceInstallmentTransferReceipts from './RealEstateFinanceInstallmentTransferReceipts.vue';
import RealEstateFinancePaymentResponsibilities from './RealEstateFinancePaymentResponsibilities.vue';

const props = defineProps({
  installment: { type: Object, default: null },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits([
  'boleto',
  'cancel',
  'download-transfer',
  'download-sheet',
  'edit-payers',
  'open-process',
  'open-installment',
  'payment',
  'release',
  'status',
  'transfer',
]);
const { t } = useI18n();
const detail = computed(() => props.installment || {});
</script>

<template>
  <div
    v-if="loading"
    data-testid="finance-installment-loading"
    class="rounded-lais border border-lais-border-soft bg-white py-12 text-center text-sm text-lais-text-muted"
  >
    {{ t('REAL_ESTATE_FINANCE.COMMON.LOADING') }}
  </div>
  <div v-else class="flex flex-col gap-5">
    <RealEstateFinanceInstallmentPaymentStatus
      :installment="detail"
      @cancel="emit('cancel')"
      @status="emit('status')"
    />
    <RealEstateFinanceInstallmentSummary
      :installment="detail"
      @open-process="emit('open-process', $event)"
      @open-installment="emit('open-installment', $event)"
      @download-sheet="emit('download-sheet', $event)"
    />
    <RealEstateFinanceInstallmentTransferReceipts
      :transfers="detail.transferencias"
      @download="emit('download-transfer', $event)"
    />
    <RealEstateFinancePaymentResponsibilities
      :can-manage-payers="detail.acoes?.pode_editar_pagadores"
      :installment="detail"
      :responsibilities="detail.parcela?.responsaveis_pagamento"
      @payment="emit('payment', $event)"
      @boleto="emit('boleto', $event)"
      @edit="emit('edit-payers')"
    />
    <RealEstateFinanceInstallmentBeneficiaries
      :beneficiaries="detail.usuarios_agrupado"
      :installment="detail"
      :loading="loading"
      :rateio="detail.rateio"
      @release="emit('release', $event)"
      @transfer="emit('transfer', $event)"
      @download-sheet="emit('download-sheet', $event)"
    />
    <RealEstateFinanceInstallmentHistory :events="detail.historico" />
  </div>
</template>
